import * as fetch from './fetch'

export function getAll(token) {
  const endpoint = '/industry/all';
  return fetch.GET(endpoint, token, true)
}

export function addIndustry(newIndustry, token) {
  const endpoint = '/industry';
  return fetch.POST(endpoint, token, newIndustry, true)
}
